import script from "./HomeView2.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeView2.vue?vue&type=script&setup=true&lang=js"

import "./HomeView2.vue?vue&type=style&index=0&id=0ad58d93&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ad58d93"]])

export default __exports__